module.exports = __webpack_public_path__ + "static/media/digitalTrans.33091eaf.png";